class AuthorizationError extends Error {
    constructor(statusCode, defaultMessage, url) {
        super(defaultMessage || "You are not authorized to perform this operation.");
  
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, AuthorizationError);
      }
  
      this.title = "Authorization Error";
      this.statusCode = statusCode;
      this.message = defaultMessage;
      this.defaultMessage = '';
      this.url = url;
    }
  }
  
  export default AuthorizationError;
  